import { render, staticRenderFns } from "./SemAutorizacao.vue?vue&type=template&id=934bf3e4"
import script from "./SemAutorizacao.vue?vue&type=script&lang=js"
export * from "./SemAutorizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports